import { Button, TextRegular } from "@hm/fundamental"

interface ModalFormActionsProps {
	hint: string
	cancelLabel: string
	submitLabel: string
	isSubmitDisabled: boolean
	onCancel: () => void
	onSubmit: () => void
	"data-cy": string
}

export const ModalFormActions: React.FC<ModalFormActionsProps> = ({
	hint,
	cancelLabel,
	submitLabel,
	isSubmitDisabled,
	onCancel,
	onSubmit,
	"data-cy": dataCy,
}) => (
	<div
		data-cy={`${dataCy}-actions`}
		className="flex items-center justify-between gap-4 max-md:flex-col"
	>
		<TextRegular className="text-foreground_faded">{hint}</TextRegular>
		<div className="flex gap-3">
			<Button
				data-cy={`${dataCy}-cancel`}
				variant="secondary"
				type="button"
				onClick={onCancel}
			>
				{cancelLabel}
			</Button>
			<Button
				data-cy={`${dataCy}-submit`}
				type="button"
				disabled={isSubmitDisabled}
				onClick={onSubmit}
			>
				{submitLabel}
			</Button>
		</div>
	</div>
)
